export default class Translations {

  static get(key: string) {
    return key;
  }

}
